import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import {components, MenuListProps, OptionProps} from "react-select";
import {debounce} from "lodash";

type AsyncMultiSelectorProps = {
    placeholder: string;
    onChange: (value: string[]) => void;
    getOptions: (inputValue: string) => Promise<OptionType[]>;
}

type OptionType = {
    value: string;
    label: string;
}

const highlightInputMatch = (item: string | undefined, keyword: string) => {
    if (!item || !keyword) return item;
    const lowerCasedInputValue = keyword.toLowerCase();
    const hitIndex = item.toLocaleLowerCase().indexOf(lowerCasedInputValue);
    if (hitIndex === -1) return item;
    const before = item.slice(0, hitIndex);
    const match = item.slice(hitIndex, hitIndex + keyword.length);
    const after = item.slice(hitIndex + keyword.length);
    return (
        <span>
      {before}
            <b>{match}</b>
            {after}
    </span>
    );
};

const Option = (props: OptionProps<OptionType>) => {
    const inputValue = props.selectProps.inputValue;
    const {data} = props

    return (
        <components.Option {...props}>
            {highlightInputMatch(data.label, inputValue)}
        </components.Option>
    );
};

const NoOptionsMessage = (props: MenuListProps<OptionType>) => {
    return (
        <components.NoOptionsMessage {...props}>
            Type to search...
        </components.NoOptionsMessage>
    );
}

export const AsyncMultiSelector: React.FC<AsyncMultiSelectorProps> = ({onChange, getOptions, placeholder}) => {
    const debouncedLoadOptions = React.useMemo(
        () =>
            debounce(
                (inputValue: string, callback: (opts: OptionType[]) => void) => {
                    getOptions(inputValue).then(callback);
                },
                500
            ),
        [getOptions]
    );


    return (
        <AsyncCreatableSelect
            placeholder={placeholder}
            isMulti
            defaultOptions={false}
            loadOptions={debouncedLoadOptions}
            onChange={(options: OptionType[]) => onChange(options.map(option => option.value))}
            allowCreateWhileLoading={true}
            formatCreateLabel={(inputValue: string) => `${inputValue}`}
            createOptionPosition="first"
            components={{ NoOptionsMessage, Option }}
        />
    )
}
